module.exports = __webpack_public_path__ + "img/profitable-img-5.594872aa.png";